import { blackOrange, textMuted } from '@/theme/colors'
import { fontBody } from '@/theme/fonts'
import styled from 'styled-components'

export const Centered = styled.div`
	flex: 1;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	padding: 2rem;
	text-align: center;
`

export const SpinnerWrap = styled.div`
	margin-bottom: 1.25rem;
`

export const StateTitle = styled.h1`
	font-size: 1.4rem;
	font-weight: 700;
	color: ${blackOrange};
	margin: 1rem 0 0.625rem;
`

export const StateMessage = styled.p`
	font-family: ${fontBody};
	font-size: 0.95rem;
	color: ${textMuted};
	margin: 0;
	max-width: 380px;
	line-height: 1.6;
`
